var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContributionInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5585",
    "data-name": "Group 5585",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.581,
    height: 22.227,
    viewBox: "0 0 22.581 22.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5257",
    "data-name": "Group 5257",
    transform: "translate(0.771 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    d: "M969.384,560.743a1.5,1.5,0,0,1-1.064-.441l-1.419-1.419a.5.5,0,0,1,.709-.709l1.419,1.419a.513.513,0,0,0,.709,0l11.353-11.352a.5.5,0,0,0,0-.71l-7.449-7.449a.5.5,0,0,0-.709,0l-11.352,11.352a.5.5,0,0,0,0,.71l2.128,2.128a.5.5,0,0,1-.709.709l-2.129-2.128a1.508,1.508,0,0,1,0-2.129l11.353-11.352a1.506,1.506,0,0,1,2.128,0l7.45,7.449a1.508,1.508,0,0,1,0,2.129L970.448,560.3A1.492,1.492,0,0,1,969.384,560.743Z",
    transform: "translate(-960.43 -538.931)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5258",
    "data-name": "Group 5258",
    transform: "translate(12.631 2.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    d: "M984.571,548.022a.513.513,0,0,1-.078-.006.5.5,0,0,1-.418-.573l.584-3.736a.5.5,0,0,1,.992.155l-.585,3.736A.5.5,0,0,1,984.571,548.022Z",
    transform: "translate(-984.069 -543.283)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5259",
    "data-name": "Group 5259",
    transform: "translate(9.434 14.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M978.2,573.383a.489.489,0,0,1-.054,0,.5.5,0,0,1-.445-.552l.458-4.222a.5.5,0,1,1,1,.108l-.458,4.222A.5.5,0,0,1,978.2,573.383Z",
    transform: "translate(-977.697 -568.157)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5260",
    "data-name": "Group 5260",
    transform: "translate(15.518 8.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    d: "M990.325,557.491a.5.5,0,0,1-.053-1l4.222-.458a.506.506,0,0,1,.552.445.5.5,0,0,1-.445.552l-4.222.458Z",
    transform: "translate(-989.824 -556.03)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5261",
    "data-name": "Group 5261",
    transform: "translate(3.023 11.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3548",
    "data-name": "Path 3548",
    d: "M965.419,564.023a.5.5,0,0,1-.077-1l3.736-.584a.5.5,0,1,1,.155.992l-3.737.584A.507.507,0,0,1,965.419,564.023Z",
    transform: "translate(-964.918 -562.436)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5262",
    "data-name": "Group 5262",
    transform: "translate(0 14.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    d: "M959.395,572.884a.5.5,0,0,1-.355-.856l3.723-3.723a.5.5,0,0,1,.71.709l-3.723,3.723A.5.5,0,0,1,959.395,572.884Z",
    transform: "translate(-958.893 -568.157)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5263",
    "data-name": "Group 5263",
    transform: "translate(0 16.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    d: "M959.395,577.658a.5.5,0,0,1-.355-.856l4.612-4.612a.5.5,0,0,1,.709.709l-4.612,4.612A.5.5,0,0,1,959.395,577.658Z",
    transform: "translate(-958.893 -572.043)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5264",
    "data-name": "Group 5264",
    transform: "translate(3.193 16.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M965.759,577.3a.5.5,0,0,1-.355-.856l4.257-4.256a.5.5,0,0,1,.709.709l-4.257,4.256A.5.5,0,0,1,965.759,577.3Z",
    transform: "translate(-965.257 -572.043)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5265",
    "data-name": "Group 5265",
    transform: "translate(8.245 7.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M977.959,560.421a2.825,2.825,0,0,1-1.62-.428,2.25,2.25,0,0,1-.985-1.526,2.022,2.022,0,0,1,.416-1.6,3.092,3.092,0,0,0,2.592-2.593h0a2.021,2.021,0,0,1,1.6-.415,2.249,2.249,0,0,1,1.526.985,4.238,4.238,0,0,1,.318,2.975,15.688,15.688,0,0,0-.139,1.856.5.5,0,0,1-.5.5,15.581,15.581,0,0,0-1.857.139A11.868,11.868,0,0,1,977.959,560.421Zm-.367-3.427a1.4,1.4,0,0,0-1.039.5,1.034,1.034,0,0,0-.208.819,1.244,1.244,0,0,0,.545.843,3.475,3.475,0,0,0,2.306.161c.448-.053.941-.111,1.483-.135.025-.541.082-1.035.135-1.482a3.485,3.485,0,0,0-.161-2.307,1.244,1.244,0,0,0-.843-.544,1.041,1.041,0,0,0-.82.207h0a1.314,1.314,0,0,0-.445,1.346.5.5,0,0,1-.646.646A.872.872,0,0,0,977.592,556.994Z",
    transform: "translate(-975.328 -553.828)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContributionInactive);
export default __webpack_public_path__ + "static/media/contributionInactive.8e705c4d4809f8bb93b5165f5cb7c87b.svg";
export { ForwardRef as ReactComponent };